import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { getAssetUrl } from '../../config';
import { formatItemPrice, formatPrice, hasPrice } from '../../utils/price';

const CartPage = () => {
  const { items, totalCount, totalPrice, hasUnpricedItems, updateQuantity, removeItem } = useCart();

  if (items.length === 0) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-12 text-center">
        <h1 className="text-3xl font-bold mb-4">Корзина</h1>
        <p className="text-slate-600 mb-6">Вы ещё не добавили товары.</p>
        <Link to="/catalog" className="btn-primary">Перейти в каталог</Link>
      </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Корзина</h1>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2 space-y-4">
          {items.map((item) => (
            <div key={item.id} className="bg-white rounded-2xl shadow-md p-4 flex gap-4">
              <div className="w-24 h-24 rounded-xl bg-slate-50 overflow-hidden flex items-center justify-center flex-shrink-0">
                {item.image ? (
                  <img src={getAssetUrl(item.image)} alt={item.name} className="max-h-full max-w-full object-contain" />
                ) : (
                  <span className="text-xs text-gray-400">Нет фото</span>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <h2 className="font-semibold text-lg">{item.name}</h2>
                <p className="text-primary font-bold mt-1">{formatItemPrice(item.price)}</p>
                <div className="mt-3 flex items-center gap-3">
                  <div className="flex items-center border border-slate-200 rounded-xl overflow-hidden">
                    <button type="button" className="px-3 py-1" onClick={() => updateQuantity(item.id, item.quantity - 1)}>−</button>
                    <span className="px-3 py-1">{item.quantity}</span>
                    <button type="button" className="px-3 py-1" onClick={() => updateQuantity(item.id, item.quantity + 1)}>+</button>
                  </div>
                  <button type="button" onClick={() => removeItem(item.id)} className="text-sm text-red-600 hover:underline">
                    Удалить
                  </button>
                </div>
              </div>
              <div className="font-bold whitespace-nowrap">
                {hasPrice(item.price) ? formatPrice(item.price * item.quantity) : 'Цена по запросу'}
              </div>
            </div>
          ))}
        </div>
        <div className="bg-white rounded-2xl shadow-md p-6 h-fit">
          <h2 className="text-xl font-bold mb-4">Итого</h2>
          <p className="text-slate-600 mb-1">Товаров: {totalCount}</p>
          <p className="text-2xl font-extrabold text-primary mb-2">{formatPrice(totalPrice)}</p>
          {hasUnpricedItems && (
            <p className="text-sm text-amber-800 mb-6">Часть позиций без цены — менеджер уточнит стоимость.</p>
          )}
          <Link to="/checkout" className="btn-primary w-full">Оформить заказ</Link>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
